import { useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";

const LINKS = [
  { label: "What is Fractional Funding?", href: "#how-it-works" },
  { label: "The 60:40 Rule", href: "#capital-ratio" },
  { label: "Live Orders", href: "#liquidity-board" },
  { label: "Opportunities", href: "#opportunities" },
  { label: "Yield Calculator", href: "#calculator" },
  { label: "FAQ", href: "#faq" },
];

export const BrandLockup = ({ dark = false, base = "" }) => (
  <a href={`${base}#hero`} className="flex items-end gap-2" data-testid="brand-logo-link">
    <span className={`font-heading text-2xl font-black tracking-tight leading-none ${dark ? "text-white" : "text-slate-900"}`}>
      fraction
    </span>
    <span className={`flex items-center gap-1.5 pb-0.5 text-[11px] font-semibold ${dark ? "text-slate-300" : "text-slate-500"}`}>
      by
      <img
        src={dark ? "/assets/frantiger_logo_white.png" : "/assets/frantiger_logo_1.png"}
        alt="frantiger logo"
        className="h-4 w-auto"
        data-testid="brand-frantiger-logo"
      />
    </span>
  </a>
);

export default function Navbar({ base = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 px-4 pt-4" data-testid="nav-main-header">
      <nav className="glass-surface mx-auto flex max-w-6xl items-center justify-between gap-4 rounded-full py-2.5 pl-6 pr-2.5 shadow-lg shadow-slate-900/5">
        <BrandLockup base={base} />
        <div className="hidden items-center gap-6 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={`${base}${l.href}`}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm font-semibold text-slate-600 transition-colors hover:text-orange-600"
            >
              {l.label}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <a
            href="https://wa.me/919548444445"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-link"
            className="hidden h-10 w-10 items-center justify-center rounded-full bg-emerald-50 text-emerald-600 transition-colors hover:bg-emerald-100 sm:flex"
            aria-label="Chat on WhatsApp"
          >
            <MessageCircle className="h-4 w-4" />
          </a>
          <a
            href={`${base}#lead-form`}
            data-testid="nav-join-waitlist-btn"
            className="clay-btn rounded-full bg-orange-500 px-5 py-2.5 text-sm font-bold text-white"
          >
            Join Investor Waitlist
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-700 lg:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>
      {open && (
        <div className="glass-surface mx-auto mt-2 flex max-w-6xl flex-col gap-1 rounded-3xl p-4 shadow-xl lg:hidden" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={`${base}${l.href}`}
              onClick={() => setOpen(false)}
              className="rounded-2xl px-4 py-3 text-sm font-semibold text-slate-700 transition-colors hover:bg-orange-50 hover:text-orange-600"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
